/* import __COLOCATED_TEMPLATE__ from './segments.hbs'; */
/* RESPONSIBLE TEAM: team-conversations */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

export default class SegmentsComponent extends Component {
  @service declare appService: AppService;
  @service declare intl: IntlService;

  get app() {
    return this.appService.app;
  }

  get columns() {
    return [
      {
        valuePath: 'name',
        label: this.intl.t('settings.company-segments.segment-name'),
        isSortable: true,
      },
      {
        valuePath: 'companies',
        label: this.intl.t('settings.company-segments.companies'),
        isSortable: true,
      },
      {
        valuePath: 'delete',
      },
    ];
  }

  get nonDeletedSegments() {
    return this.app.companySegments.filter((segment: any) => !segment.isDeleted);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Data::Companies::Segments': typeof SegmentsComponent;
  }
}
